(function () {
  if (!location.pathname.startsWith("/products/")) return;

  function fillZipAndClick(lat, lon) {
    fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`
    )
      .then(r => r.json())
      .then(d => {
        console.log("🧾 OSM response:", d);

        const zip = d.address?.postcode;
        if (!zip) {
          console.log("❌ ZIP not found");
          return;
        }

        $(".pincode-checker .pincode-input-container .input-group .input").val(zip);
        $(".pincode-checker .pincode-input-container .checkButton").trigger("click");

        console.log("✅ ZIP auto-filled (location allowed):", zip);
      });
  }

  navigator.geolocation.getCurrentPosition(
    pos => {
      console.log("✅ Location allowed by user");
      fillZipAndClick(pos.coords.latitude, pos.coords.longitude);
    },

    err => {
      console.log("❌ Location denied by user");
      console.log("➡️ ZIP will NOT be auto-filled");
      fetch("https://ipinfo.io/json")
        .then(r => r.json())
        .then(data => {
          console.log("ℹ️ City hint (IP-based):", data.city);
        });
    },

    {
      enableHighAccuracy: true,
      timeout: 20000,
      maximumAge: 0
    }
  );
})();



